import { JSX } from 'react'
import { Navigate, Route } from 'react-router-dom'

import { useAppStore } from '@/stores/appStore'
import { RouterLink } from '@/types'

import { ROUTER_PUBLIC_LINKS } from './config'

function AuthorizedRoute(Component: () => JSX.Element, routeConfig: RouterLink) {
  const ability = useAppStore((state) => state.ability)

  if (!ability.can(routeConfig.ability.action, routeConfig.ability.screen)) {
    return <Route element={<Navigate to={ROUTER_PUBLIC_LINKS.not_authorized.path} />} path={routeConfig.path} />
  }

  return <Route element={<Component />} path={routeConfig.path} />
}

export { AuthorizedRoute }
